import {
	GET_FUND_TRANSFER_REQUEST,
	GET_FUND_TRANSFER_SUCCESS,
	GET_FUND_TRANSFER_ERROR,
	GET_ONE_FUND_TRANSFER_REQUEST,
	GET_ONE_FUND_TRANSFER_SUCCESS,
	GET_ONE_FUND_TRANSFER_ERROR,
	ADD_FUND_TRANSFER_REQUEST,
	ADD_FUND_TRANSFER_SUCCESS,
	ADD_FUND_TRANSFER_ERROR,
	UPDATE_FUND_TRANSFER_REQUEST,
	UPDATE_FUND_TRANSFER_SUCCESS,
	UPDATE_FUND_TRANSFER_ERROR,
	DELETE_FUND_TRANSFER_REQUEST,
	DELETE_FUND_TRANSFER_SUCCESS,
	DELETE_FUND_TRANSFER_ERROR,
} from "../actions/types";
export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case ADD_FUND_TRANSFER_REQUEST:
			return {
				loading: true,
			};
		case ADD_FUND_TRANSFER_SUCCESS:
			return {
				...state,
				loading: false,
				payloadSuccess: [payload],
			};
		case ADD_FUND_TRANSFER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		case UPDATE_FUND_TRANSFER_REQUEST:
			return {
				loading: true,
			};
		case UPDATE_FUND_TRANSFER_SUCCESS:
			return {
				...state,
				loading: false,
				payloadUpdate: [payload],
			};
		case UPDATE_FUND_TRANSFER_ERROR:
			return {
				...state,
				loading: false,
				payload: [payload],
			};


		case DELETE_FUND_TRANSFER_REQUEST:
			return {
				loading: true,
			};
		case DELETE_FUND_TRANSFER_SUCCESS:
			return {
				...state,
				loading: false,
				payloadDelete: [payload],
			};
		case DELETE_FUND_TRANSFER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_ONE_FUND_TRANSFER_REQUEST:
			return {
				loading: true,
			};
		case GET_ONE_FUND_TRANSFER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: payload,
			};
		case GET_ONE_FUND_TRANSFER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_FUND_TRANSFER_REQUEST:
			return {
				loading: true,
			};
		case GET_FUND_TRANSFER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: payload,
			};
		case GET_FUND_TRANSFER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		default:
			return state;
	}
}
